module.exports = {
	init: function(){
		this.loghandler();
	},
	loghandler: function(){
		window.addEventListener('scroll', function(e) {
			var wH = common_ui.getWindowSize().height;
			var s = common_ui.getScrollValue();
			var point = (wH/1.5) + s;
			$('.js_fadeIn').not('.is_active').each(function(index, el) {
				var top = $(this).offset().top;
				if(top < point){
					$(this).addClass('is_active');
				}
			});
		});
	}
}


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/modules/fadein.js
// module id = 6
// module chunks = 0